import { motion } from 'framer-motion'
import styled from 'styled-components/macro'

import { Overlay, styleReset } from 'styles/misc'
import { mq, ScreenSize } from 'styles/mq'
import { theme } from 'styles/theme'

export const MenuToggle = styled.button`
  ${styleReset}
  display: block;
  font-size: 3.5rem;
  padding: 0;
  cursor: pointer;

  &,
  svg {
    display: block;
    width: 1em;
  }
`

export const Backdrop = styled(motion.button)`
  ${Overlay}
  ${styleReset}
  position: fixed;
  -webkit-tap-highlight-color: transparent;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 1;
`

export const MenuWrapper = styled(motion.div)`
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  height: 100svh;
  transform: translate3d(0, 0, 0);
  padding: var(--header-height) 0 0 4rem;
  overflow: hidden;
  pointer-events: none;
  border-left: 1px solid currentColor;
  color: ${theme.colors.accent.secondary};
  font-size: 1.9rem;
  text-transform: uppercase;
  line-height: 1.4;

  ${mq.smallOnly} {
    width: 100%;
    padding: calc(var(--header-height) + 2rem) 0 0;
    border-left: none;
    color: white;
  }

  ${mq.small} {
    font-size: 2.1rem;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    top: var(--header-height);
    background-color: white;
    z-index: -1;

    ${mq.smallOnly} {
      background-color: ${theme.colors.accent.primary};
    }
  }
`

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 36rem;
  height: 100%;
  box-sizing: content-box;
  padding-right: calc(
    var(--container-spacing) + 50vw - (${ScreenSize.LG / 20}rem)
  );
  pointer-events: auto;
  overflow-y: auto;

  ${mq.smallOnly} {
    padding: 0 2rem;
    width: 100%;
    box-sizing: border-box;
  }
`

export const MenuList = styled.ul`
  flex-grow: 1;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;

  button {
    ${styleReset}
    cursor: pointer;
    text-transform: inherit;
  }
`

export const Li = styled.li<{ hiddenOnLarge?: boolean }>`
  padding: 0;
  border-bottom: 1px solid #ffffff88;
  font-weight: bold;

  ${mq.medium} {
    border-bottom-color: ${theme.colors.accent.secondary}88;
  }

  ${mq.large} {
    padding-right: 2rem;
  }

  a,
  button,
  span {
    display: block;
    padding: 1rem 0 0.4rem;
    color: inherit;
    text-decoration: none;

    &:hover,
    &:focus-visible,
    &.active {
      ${mq.smallOnly} {
        font-weight: bold;
      }

      ${mq.medium} {
        color: ${theme.colors.accent.primary};
      }
    }
  }

  span {
    font-weight: normal;
  }

  svg {
    font-size: 2.4rem;
    vertical-align: baseline;
    margin: 0 0.5rem -0.5rem 0;
  }
`

export const Years = styled(motion.ul)`
  list-style: none;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(4, max-content);
  gap: 0 4rem;
  padding: 0.5rem 0 0 3.4rem;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    height: 3rem;
    grid-column-start: 1;
  }

  a {
    padding: 0.2rem 0;
  }
`

export const Social = styled.div`
  position: sticky;
  bottom: 0;
  margin: 10rem -2rem 0;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
  border-top: 1px solid ${theme.colors.accent.secondary}88;
  color: black;
  background-color: white;

  ${mq.medium} {
    color: inherit;
    margin: 10rem 0 0;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    height: 10rem;
    margin-bottom: 1px;
    background: linear-gradient(
      to top,
      ${theme.colors.accent.primary} 10%,
      ${theme.colors.accent.primary}00
    );

    ${mq.medium} {
      padding: 2rem 0 1.5rem;
      background: linear-gradient(to top, white 10%, rgba(255, 255, 255, 0));
    }
  }
`
